import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-timetable-flex',
  templateUrl: './timetable-flex.component.html',
  styleUrls: ['./timetable-flex.component.scss']
})
export class TimetableFlexComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) { }
  
  batchId: any = 0;
  batch: any = {};
  currentWeekStart: Date = new Date();
  currentWeekEnd: Date = new Date();
  weekDates: any[] = [];
  timetableData: any = {};
  topics: any = [];
  loading: boolean = false;
  
  selectedSlot: any = {
    slot_id: 0,
    topic_id: 0,
    subject: "",
    faculty: {
      id: 0,
      name: ""
    }
  };
  
  facultiesDrop: any = [];
  
  // Slot management
  newSlot: any = {
    date: '',
    start_time: '10:00',
    end_time: '11:00',
    is_break: 0
  };
  
  editingSlotId: any = 0;
  editSlot: any = {
    start_time: '',
    end_time: '',
    is_break: 0
  };
  
  // Bulk operations
  bulkDates: string = ''; // comma-separated string
  bulkSlotStructure: any[] = [{start_time: '10:00', end_time: '11:00', is_break: 0}];
  
  copyFromDate: string = '';
  copyToDates: string = ''; // comma-separated string

  ngOnInit(): void {
    this.batchId = this.route.snapshot.paramMap.get('batchId');
    this.setCurrentWeek();
    this.loadData();
    this.loadTopics();
    this.loadBatch();
  }

  setCurrentWeek() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Monday
    
    this.currentWeekStart = new Date(today.setDate(diff));
    this.currentWeekEnd = new Date(this.currentWeekStart);
    this.currentWeekEnd.setDate(this.currentWeekStart.getDate() + 6);
    
    this.generateWeekDates();
  }

  generateWeekDates() {
    this.weekDates = [];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    
    for (let i = 0; i < 7; i++) {
      const date = new Date(this.currentWeekStart);
      date.setDate(this.currentWeekStart.getDate() + i);
      
      this.weekDates.push({
        date: date,
        dateString: this.formatDate(date),
        dayName: days[date.getDay()],
        dayShort: days[date.getDay()].substring(0, 3)
      });
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  loadData() {
    this.loading = true;
    const startDate = this.formatDate(this.currentWeekStart);
    const endDate = this.formatDate(this.currentWeekEnd);
    
    this.dataService.getTimetableFlex(this.batchId, startDate, endDate).subscribe((data: any) => {
      if (data.status == 0) {
        this.timetableData = data.data;
      }
      this.loading = false;
    });
  }

  loadTopics() {
    this.dataService.getBatchTopics(this.batchId).subscribe((data: any) => {
      if (data.status == 0) {
        this.topics = data.topics;
      }
    });
  }

  loadBatch() {
    this.dataService.getBatch(this.batchId).subscribe((data: any) => {
      if (data.status == 0) {
        this.batch = data;
      }
    });
  }

  prevWeek() {
    this.currentWeekStart.setDate(this.currentWeekStart.getDate() - 7);
    this.currentWeekEnd.setDate(this.currentWeekEnd.getDate() - 7);
    this.generateWeekDates();
    this.loadData();
  }

  nextWeek() {
    this.currentWeekStart.setDate(this.currentWeekStart.getDate() + 7);
    this.currentWeekEnd.setDate(this.currentWeekEnd.getDate() + 7);
    this.generateWeekDates();
    this.loadData();
  }

  goToToday() {
    this.setCurrentWeek();
    this.loadData();
  }

  getSlotsForDate(dateString: string): any[] {
    return this.timetableData[dateString] || [];
  }

  openAddSlotModal(dateString: string) {
    this.newSlot.date = dateString;
    const slots = this.getSlotsForDate(dateString);
    this.newSlot.order = slots.length + 1;
    //@ts-ignore
    $("#modal-add-slot").modal("show");
  }

  addSlot() {
    const data = {
      batch_id: this.batchId,
      slot_date: this.newSlot.date,
      slot_order: this.newSlot.order,
      start_time: this.newSlot.start_time,
      end_time: this.newSlot.end_time,
      is_break: this.newSlot.is_break
    };

    this.dataService.addFlexSlot(data).subscribe((res: any) => {
      if (res.status == 0) {
        //@ts-ignore
        $("#modal-add-slot").modal("hide");
        this.loadData();
        this.resetNewSlot();
      } else {
        alert(res.msg);
      }
    });
  }

  resetNewSlot() {
    this.newSlot = {
      date: '',
      start_time: '10:00',
      end_time: '11:00',
      is_break: 0
    };
  }

  openEditSlotModal(slot: any) {
    this.editingSlotId = slot.slot_id;
    this.editSlot = {
      start_time: slot.start_time,
      end_time: slot.end_time,
      is_break: slot.is_break
    };
    //@ts-ignore
    $("#modal-edit-slot").modal("show");
  }

  updateSlot() {
    const data = {
      slot_id: this.editingSlotId,
      start_time: this.editSlot.start_time,
      end_time: this.editSlot.end_time,
      is_break: this.editSlot.is_break
    };

    this.dataService.editFlexSlot(data).subscribe((res: any) => {
      if (res.status == 0) {
        //@ts-ignore
        $("#modal-edit-slot").modal("hide");
        this.loadData();
      } else {
        alert(res.msg);
      }
    });
  }

  deleteSlot(slotId: any) {
    if (confirm("Are you sure you want to delete this slot?")) {
      this.dataService.deleteFlexSlot(slotId).subscribe((res: any) => {
        if (res.status == 0) {
          this.loadData();
        } else {
          alert(res.msg);
        }
      });
    }
  }

  openAssignModal(slot: any) {
    this.selectedSlot = {
      slot_id: slot.slot_id,
      topic_id: slot.data.topic_id,
      subject: slot.data.subject,
      faculty: {
        id: slot.data.faculty.id,
        name: slot.data.faculty.name
      }
    };

    if (slot.data.topic_id > 0) {
      let topic = this.topics.find((item: any) => item.id == slot.data.topic_id);
      if (topic) {
        this.facultiesDrop = topic.faculties;
      }
    }

    //@ts-ignore
    $("#modal-assign").modal("show");
  }

  setDisplayText(val: any) {
    let topic = this.topics.find((item: any) => item.id == val);
    if (topic) {
      this.selectedSlot.subject = topic.topic;
      this.facultiesDrop = topic.faculties;
    }
  }

  setSlotFacultyName(val: any) {
    let faculty = this.facultiesDrop.find((item: any) => item.id == val);
    if (faculty) {
      this.selectedSlot.faculty.name = faculty.name;
    }
  }

  assignSlotData() {
    const data = {
      slot_id: this.selectedSlot.slot_id,
      topic_id: this.selectedSlot.topic_id,
      subject: this.selectedSlot.subject,
      faculty_id: this.selectedSlot.faculty.id
    };

    this.dataService.updateFlexSlotData(data).subscribe((res: any) => {
      if (res.status == 0) {
        //@ts-ignore
        $("#modal-assign").modal("hide");
        this.loadData();
      } else {
        alert(res.msg);
      }
    });
  }

  openCopyModal() {
    //@ts-ignore
    $("#modal-copy-structure").modal("show");
  }

  copyStructure() {
    // Parse comma-separated dates into array
    let datesArray: string[] = [];
    if (typeof this.copyToDates === 'string') {
      datesArray = this.copyToDates.split(',').map(d => d.trim()).filter(d => d.length > 0);
    } else if (Array.isArray(this.copyToDates)) {
      datesArray = this.copyToDates;
    }

    if (!this.copyFromDate) {
      alert('Please select a source date');
      return;
    }

    if (datesArray.length === 0) {
      alert('Please enter target dates');
      return;
    }

    const data = {
      from_date: this.copyFromDate,
      to_dates: datesArray,
      batch_id: this.batchId
    };

    this.dataService.copyDateStructure(data).subscribe((res: any) => {
      if (res.status == 0) {
        //@ts-ignore
        $("#modal-copy-structure").modal("hide");
        this.loadData();
        alert("Structure copied successfully!");
      } else {
        alert(res.msg);
      }
    });
  }

  openBulkCreateModal() {
    //@ts-ignore
    $("#modal-bulk-create").modal("show");
  }

  addBulkSlotRow() {
    this.bulkSlotStructure.push({start_time: '10:00', end_time: '11:00', is_break: 0});
  }

  removeBulkSlotRow(index: number) {
    this.bulkSlotStructure.splice(index, 1);
  }

  bulkCreateSlots() {
    // Parse comma-separated dates into array
    let datesArray: string[] = [];
    if (typeof this.bulkDates === 'string') {
      datesArray = this.bulkDates.split(',').map(d => d.trim()).filter(d => d.length > 0);
    } else if (Array.isArray(this.bulkDates)) {
      datesArray = this.bulkDates;
    }

    if (datesArray.length === 0) {
      alert('Please enter dates');
      return;
    }

    if (this.bulkSlotStructure.length === 0) {
      alert('Please add at least one slot');
      return;
    }

    const data = {
      dates: datesArray,
      slot_structure: this.bulkSlotStructure,
      batch_id: this.batchId
    };

    this.dataService.bulkCreateFlexSlots(data).subscribe((res: any) => {
      if (res.status == 0) {
        //@ts-ignore
        $("#modal-bulk-create").modal("hide");
        this.loadData();
        alert("Slots created successfully!");
      } else {
        alert(res.msg);
      }
    });
  }

  navigateToAttendance(slotId: any) {
    this.router.navigate(['/dashboard/subject-attendance-flex', slotId]);
  }
}
